import React, { FC } from "react";

import useStyles from "./styles";

interface IAddCardComponent {
  onAdd: () => void;
}

const AddCardComponent: FC<IAddCardComponent> = ({ onAdd }) => {
  const classes = useStyles({});
  return (
    <div className={classes.container}>
      <div className={classes.dashedLine} />
      <button
        id="addUnlockCodeCardBtn"
        onClick={onAdd}
        className={classes.addButtonContainer}
      >
        <span className={classes.addSignContainer}>+</span> ADD
      </button>
    </div>
  );
};

export default AddCardComponent;
